// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.personlisation .personlisation-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.personlisation .personlisation-header h2 {
  font-weight: 400;
  line-height: 2.08vw;
  font-size: 2.08vw;
  color: #3a3a3a;
  padding-bottom: 0.35vw;
}
.personlisation .personlisation-header p {
  font-weight: 400;
  line-height: 1.25vw;
  color: #3a3a3a;
  font-size: 0.9vw;
}
.personlisation .personlisation-header button {
  color: #ee3a24;
  border: 0.5px solid #ee3a24;
  background-color: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 0.755vw 4.22vw;
  border-radius: 2px;
}
.personlisation > .personlisation-slider {
  background-color: #fff;
  margin-top: 2.5vw;
  padding: 3.5vw 2vw;
  backdrop-filter: blur(42px);
  box-shadow: -5px -5px 250px 0px rgba(255, 255, 255, 0.0196078431) inset;
}
.personlisation > .personlisation-slider .live-text {
  font-size: 1.15vw;
  font-weight: 500;
  color: #3a3a3a;
  margin-bottom: 1.5vw;
}
.personlisation > .personlisation-slider .slider .item {
  height: calc(100% - 12px) !important;
  width: calc(100% - 24px) !important;
}
.personlisation > .personlisation-slider .slider .item img {
  margin: 0;
  height: 100% !important;
  width: 100% !important;
  border-radius: 3px 3px 0 0;
}
.personlisation > .personlisation-slider .slider .item .name-tag button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  color: #fff;
  border: 0.5px solid #ee3a24;
  background-color: #ee3a24;
  cursor: pointer;
  padding: 0.655vw 0vw;
  border-radius: 2px;
  font-size: 1.05vw;
  width: 75%;
  margin: 0 0 0 auto;
  border-radius: 3px 0 0 3px;
}
.personlisation > .personlisation-slider .slider .slick-prev:before, .personlisation > .personlisation-slider .slider .slick-next:before {
  color: transparent;
}
.personlisation > .buttons {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 2.5vw;
}
.personlisation > .buttons button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  color: #fff;
  border: 0.5px solid #ee3a24;
  background-color: #ee3a24;
  cursor: pointer;
  padding: 0.755vw 0vw;
  border-radius: 2px;
  font-size: 1.05vw;
  width: 20vw;
}
.personlisation > .buttons button:disabled {
  opacity: 0.5;
  cursor: default;
}
.personlisation > .buttons button svg {
  width: 14px;
  height: 16px;
}`, "",{"version":3,"sources":["webpack://./src/style/components/dashboard/personlisation/PersonalisationHome.scss"],"names":[],"mappings":"AACE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAAJ;AACI;EACE,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;EACA,sBAAA;AACN;AACI;EACE,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;AACN;AACI;EACE,cAAA;EACA,2BAAA;EACA,6BAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AACN;AAEE;EACE,sBAAA;EACA,iBAAA;EACA,kBAAA;EACA,2BAAA;EACA,uEAAA;AAAJ;AACI;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,oBAAA;AACN;AAEM;EACE,oCAAA;EACA,mCAAA;AAAR;AACQ;EACE,SAAA;EACA,uBAAA;EACA,sBAAA;EACA,0BAAA;AACV;AAEU;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,WAAA;EACA,2BAAA;EACA,yBAAA;EACA,eAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,UAAA;EACA,kBAAA;EACA,0BAAA;AAAZ;AAIM;EACE,kBAAA;AAFR;AAME;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;AAJJ;AAKI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,WAAA;EACA,2BAAA;EACA,yBAAA;EACA,eAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;AAHN;AAIM;EACE,YAAA;EACA,eAAA;AAFR;AAIM;EACE,WAAA;EACA,YAAA;AAFR","sourcesContent":[".personlisation {\n  .personlisation-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    h2 {\n      font-weight: 400;\n      line-height: 2.08vw;\n      font-size: 2.08vw;\n      color: #3a3a3a;\n      padding-bottom: 0.35vw;\n    }\n    p {\n      font-weight: 400;\n      line-height: 1.25vw;\n      color: #3a3a3a;\n      font-size: 0.9vw;\n    }\n    button {\n      color: #ee3a24;\n      border: 0.5px solid #ee3a24;\n      background-color: transparent;\n      cursor: pointer;\n      display: flex;\n      align-items: center;\n      padding: 0.755vw 4.22vw;\n      border-radius: 2px;\n    }\n  }\n  & > .personlisation-slider {\n    background-color: #fff;\n    margin-top: 2.5vw;\n    padding: 3.5vw 2vw;\n    backdrop-filter: blur(42px);\n    box-shadow: -5px -5px 250px 0px #ffffff05 inset;\n    .live-text {\n      font-size: 1.15vw;\n      font-weight: 500;\n      color: #3a3a3a;\n      margin-bottom: 1.5vw;\n    }\n    .slider {\n      .item {\n        height: calc(100% - 12px) !important;\n        width: calc(100% - 24px) !important;\n        img {\n          margin: 0;\n          height: 100% !important;\n          width: 100% !important;\n          border-radius: 3px 3px 0 0;\n        }\n        .name-tag {\n          button {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            gap: 5px;\n            color: #fff;\n            border: 0.5px solid #ee3a24;\n            background-color: #ee3a24;\n            cursor: pointer;\n            padding: 0.655vw 0vw;\n            border-radius: 2px;\n            font-size: 1.05vw;\n            width: 75%;\n            margin: 0 0 0 auto;\n            border-radius: 3px 0 0 3px;\n          }\n        }\n      }\n      .slick-prev:before, .slick-next:before{\n        color: transparent;\n      }\n    }\n  }\n  & > .buttons {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-top: 2.5vw;\n    button {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      gap: 5px;\n      color: #fff;\n      border: 0.5px solid #ee3a24;\n      background-color: #ee3a24;\n      cursor: pointer;\n      padding: 0.755vw 0vw;\n      border-radius: 2px;\n      font-size: 1.05vw;\n      width: 20vw;\n      &:disabled{\n        opacity: .5;\n        cursor: default;\n      }\n      svg {\n        width: 14px;\n        height: 16px;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
